function normalizeDdxConfidencePercent(confidencePercent) {
    const numericValue = Number.parseFloat(confidencePercent);

    if (!Number.isFinite(numericValue)) {
        return 0;
    }

    return Math.round(numericValue);
}

function clampDdxConfidencePercent(confidencePercent) {
    return Math.min(Math.max(confidencePercent, 0), 100);
}

function getDiagnosisSuggestionBarClassName(rank) {
    if (rank === 1) {
        return "h-full bg-creation-primary-container-on-surface-pressed";
    }

    if (rank === 2) {
        return "h-full bg-creation-primary-container-on-surface-hovered";
    }

    if (rank === 3) {
        return "h-full bg-creation-primary-container-on-surface-disabled";
    }

    return "h-full bg-creation-neutral-solid-surface-disabled";
}

function buildDiagnosisSuggestionItem(rawSuggestion = {}, index = 0) {
    const name = String(rawSuggestion.diagnosis || "").trim();
    const probability = normalizeDdxConfidencePercent(rawSuggestion.confidence_percent);
    const rank = Number.parseInt(rawSuggestion.rank, 10);
    const normalizedRank = Number.isFinite(rank) ? rank : index + 1;

    return {
        barClassName: getDiagnosisSuggestionBarClassName(normalizedRank),
        key: `${normalizedRank}-${name}`,
        name,
        probabilityLabel: `${probability}%`,
        widthPercent: clampDdxConfidencePercent(probability),
    };
}

function extractDiagnosisSuggestions(treatmentDdx) {
    if (!Array.isArray(treatmentDdx?.suggestions) || !treatmentDdx.suggestions.length) {
        return [];
    }

    return [...treatmentDdx.suggestions]
        .sort((firstItem, secondItem) => (firstItem.rank || 0) - (secondItem.rank || 0))
        .map(buildDiagnosisSuggestionItem)
        .filter((item) => item.name)
        .slice(0, 5);
}

function buildDiagnosisSuggestionListItem(item) {
    return (
        <div key={item.key} className="flex flex-col gap-2">
            <div className="flex items-start justify-between gap-3">
                <p className="min-w-0 whitespace-normal break-words text-body-small text-main-typography-system-description">
                    {item.name}
                </p>
                <p className="shrink-0 text-button-small font-header text-main-typography-system-default">
                    {item.probabilityLabel}
                </p>
            </div>
            <div className="h-[4px] w-full">
                <div
                    className={item.barClassName}
                    style={{ width: `${item.widthPercent}%` }}
                />
            </div>
        </div>
    );
}

export default function RecorderDdxSection({
    initialTreatmentDdx = null,
    isLoading,
    treatmentDdx,
}) {
    const displayedTreatmentDdx =
        treatmentDdx === undefined ? initialTreatmentDdx : treatmentDdx;
    const diagnosisSuggestions = extractDiagnosisSuggestions(
        displayedTreatmentDdx
    );

    if (isLoading || !diagnosisSuggestions.length) {
        return (
            <div className="flex h-[160px] w-full items-center justify-center bg-main-background-system-default">
                <p className="whitespace-pre-line text-center text-caption text-main-typography-system-description">
                    กำลังประมวลผล..
                    {"\n"}
                    เพื่อวินิจฉัยแยกโรค
                </p>
            </div>
        );
    }

    return (
        <div className="flex w-full flex-col gap-5 bg-main-background-system-default p-5">
            <p className="text-subtitle font-header text-main-typography-system-default">
                การวินิจฉัยแยกโรค
            </p>
            <div className="flex flex-col gap-3">
                {diagnosisSuggestions.map(buildDiagnosisSuggestionListItem)}
            </div>
            <div className="h-px w-full bg-main-border-system-default" />
            <p className="text-caption text-main-typography-system-description">
                โปรดใช้ดุลยพินิจของแพทย์ในการตรวจสอบผลเสมอ
            </p>
        </div>
    );
}
